import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { LegalDocumentAlias } from '@/models/document';

export const useLegalDocumentStore = defineStore('legalDocument', () => {
  const legalDocumentAliases = ref<LegalDocumentAlias[]>([]);

  const setLegalDocumentAliases = (data: LegalDocumentAlias[]) => {
    legalDocumentAliases.value = data;
  };

  const getDocumentSlugForAlias = (alias: string) => {
    return legalDocumentAliases.value.find((item) => item.alias === alias)?.slug ?? 'not-found';
  };

  return {
    setLegalDocumentAliases,
    getDocumentSlugForAlias
  };
});
